import { useAuthStore } from '@/stores/auth-store'
import { BannedAccountScreen } from './banned-account-screen'

interface BannedAccountGateProps {
  children: React.ReactNode
}

/** When the signed-in profile is banned, blocks the wrapped UI and shows appeals messaging. */
export function BannedAccountGate({ children }: BannedAccountGateProps) {
  const user = useAuthStore((s) => s.user)
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  if (isAuthenticated && user?.is_banned) {
    return <BannedAccountScreen />
  }

  return <>{children}</>
}
